import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiGetTestCaseDetail, apiGetTestCaseList } from './testCase.service'

const initialState = {
    status: 'loaded',
    testCase: [],
    testCaseDetailLoading: false,
    testCaseDetail: {},
    pagination: {
        currentPage: 1,
        pageSize: 10,
    },
    defaultFilter: {
        epic: [],
        sprint: '',
        tags: [],
    },
    filter: {
        epic: [],
        sprint: '',
        tags: [],
    },
    searchValue: '',
}

// LIST TEST CASES
export const testCaseList = createAsyncThunk(
    'testCaseListSlice/read',
    async (payload = {}) => {
        // const response = await getSprintsList(payload)
        const response = await apiGetTestCaseList(payload)
        return response
    }
)

// GET TEST CASE DETAIL
export const testCaseDetail = createAsyncThunk(
    'testCaseListSlice/details',
    async (payload = {}) => {
        // const response = await getSprintsList(payload)
        const response = await apiGetTestCaseDetail(payload)
        return response
    }
)

export const testCaseListSlice = createSlice({
    name: 'testCaseListSlice',
    initialState,
    reducers: {
        setPagination: (state, action) => {
            state.pagination = action.payload
            // state.selectedSprint = undefined
            // state.selectedSprintData = undefined
        },
        setSearchValue: (state, action) => {
            state.searchValue = action.payload
        },
        setFilter: (state, action) => {
            state.filter = action.payload
        },
        switchTab: (state, action) => {
            state.selectedSprintTab = action.payload
        },
        searchSprints: (state, action) => {
            state.search = action.payload
        },
        setSprintTasks: (state, action) => {
            state.listTasks = action.payload
        },
        setSprints: (state, action) => {
            state.sprints = action.payload
        },
        setEpics: (state, action) => {
            state.epics = action.payload
        },
        clearSprints: (state) => {
            state.search = ''
            state.sprints = []
            state.selectedSprint = undefined
        },
        setPointerEvent: (state, action) => {
            state.pointerEvent = action.payload
        },
        changeEditInput: (state, action) => {
            state.editInput = {
                id: action.payload.id,
                open: action.payload.open,
            }
        },
        changeEditTaskInput: (state, action) => {
            state.editTaskInput = {
                id: action.payload.id,
                open: action.payload.open,
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(testCaseList.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(testCaseList.fulfilled, (state, action) => {
                state.status = 'loaded'
                state.testCase = action.payload.data
            })
            .addCase(testCaseDetail.pending, (state) => {
                state.testCaseDetailLoading = true
            })
            .addCase(testCaseDetail.fulfilled, (state, action) => {
                state.testCaseDetailLoading = false
                state.testCaseDetail = action.payload.data
            })
    },
})

export default testCaseListSlice.reducer

export const testCaseState = (state) => {
    const { testCaseListSlice } = state
    const {
        status,
        testCase,
        testCaseDetailLoading,
        testCaseDetail,
        pagination,
        searchValue,
        filter,
        defaultFilter,
    } = testCaseListSlice
    return {
        status,
        testCase,
        testCaseDetailLoading,
        testCaseDetail,
        pagination,
        searchValue,
        filter,
        defaultFilter,
    }
}

export const {
    setSearchValue,
    setPagination,
    setFilter,
    switchViewModal,
    searchSprints,
    setSprints,
    clearSprints,
    setEpics,
    changeEditInput,
    changeEditTaskInput,
    setPointerEvent,
    switchTab,
    sprintSelect,
    clearSprintSelect,
    setSprintTasks,
} = testCaseListSlice.actions
